<template>
  <div>
    <a-menu v-model="current" mode="horizontal">
      <a-menu-item key="mail">
        <a-icon type="mail" /> Hồ sơ nhân viên
      </a-menu-item>
      <a-menu-item key="app"> <a-icon type="appstore" /> Hợp đồng </a-menu-item>
      <a-sub-menu>
        <span slot="title" class="submenu-title-wrapper">
          <a-icon type="setting" /> Đào tạo
        </span>
        <a-menu-item-group title="Item 1">
          <a-menu-item key="setting:1">
            Các khóa đào tạo
          </a-menu-item>
          <a-menu-item key="setting:2">
            Ds giảng viên
          </a-menu-item>
        </a-menu-item-group>
        <a-menu-item-group title="Item 2">
          <a-menu-item key="setting:3">
            Option 3
          </a-menu-item>
          <a-menu-item key="setting:4">
            Option 4
          </a-menu-item>
        </a-menu-item-group>
      </a-sub-menu>
      <a-menu-item key="chamcong">
        <a-icon type="setting" /> Chấm công
      </a-menu-item>
      <a-menu-item key="congtacs">
        <a-icon type="setting" /> Quá trình Công tác
      </a-menu-item>
      <a-menu-item key="setting1">
        <a-icon type="setting" /> Kỷ luât / Khen thưởng
      </a-menu-item>
      <a-menu-item key="setting2">
        <a-icon type="setting" /> Nghỉ phép
      </a-menu-item>
      <a-menu-item key="setting3">
        <a-icon type="setting" /> Cấu hình
      </a-menu-item>
    </a-menu>
  </div>
</template>
<script>
export default {
  data() {
    return {
      current: ["mail"],
    };
  },
};
</script>
